export const buildNumber = '20260831.6';
export const version = 'main';
export const latestCommit = '80a3ec945ec67ebfa63b18bfe6a957031d74c183';
